var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 32C28.1797 32 34 26.1797 34 19C34 11.8203 28.1797 6 21 6C13.8203 6 8 11.8203 8 19C8 26.1797 13.8203 32 21 32ZM21 34C29.2843 34 36 27.2843 36 19C36 10.7157 29.2843 4 21 4C12.7157 4 6 10.7157 6 19C6 27.2843 12.7157 34 21 34Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2703 31.5122L31.2616 31.6242L31.0066 32.5467L38.9361 41.9966L40.187 40.9469L32.2703 31.5122ZM28.7989 33.027L37.404 43.2822C38.114 44.1284 39.3755 44.2387 40.2217 43.5287L41.4726 42.479C42.3188 41.769 42.4291 40.5075 41.7191 39.6614L33.114 29.4062L29.6947 29.7858L28.7989 33.027Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4427 38.9382L37 41L35.71 39.4717L38.1526 37.4099L39.4427 38.9382Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.748 10.8156C19.0074 10.8834 17.4354 11.5044 16.5945 12.3455C16.204 12.736 15.5709 12.7361 15.1803 12.3456C14.7897 11.9551 14.7897 11.3219 15.1802 10.9314C16.4775 9.63376 18.5889 8.89812 20.6702 8.81715C22.7652 8.73565 25.0522 9.30929 26.6539 10.9112C27.0444 11.3018 27.0443 11.935 26.6537 12.3255C26.2632 12.7159 25.63 12.7159 25.2395 12.3253C24.1485 11.2341 22.475 10.7484 20.748 10.8156Z",
    fill: "#333333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/detail.35118136cbef9efac00f5ef71bef3347.svg";
export { ForwardRef as ReactComponent };